<template>
  <Drawer
    class="drawer_modal"
    width="700"
    v-model="showDrawer"
  >
    <customerDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></customerDetail>

    <customerForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></customerForm>

  </Drawer>
</template>

<script>
  import { BaseItemData } from "../../base/base_item.js";

  import customerForm from "@/apps/debtor/debtorForm.vue";
  import customerDetail from "@/apps/debtor/debtorDetail.vue";

  let _app = BaseItemData();
  _app.components = {
    customerDetail,
    customerForm,
  };
  _app.data = function() {
    return {
      titles: {
        detail: "Должник",
        edit: "Редактирование должника",
        create: "Создание должника",
        debt_repayment_create: "Погашение",
      },
      itemAction: "detail",
      itemId: "",
      showDrawer: false
    };
  };
  export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/debtor/debtorItem.vue